import type { HirarcAssessment } from "../types/domain";

export type HirarcBand = "low" | "medium" | "high";

export const clampRating = (value: number): number =>
  Math.min(5, Math.max(1, Number.isFinite(value) ? Math.round(value) : 1));

export const hirarcScore = (likelihood: number, severity: number): number =>
  clampRating(likelihood) * clampRating(severity);

export const hirarcBand = (score: number): HirarcBand =>
  score >= 15 ? "high" : score >= 5 ? "medium" : "low";

export const hirarcBandLabel = (score: number): "High" | "Medium" | "Low" => {
  const band = hirarcBand(score);
  return band === "high" ? "High" : band === "medium" ? "Medium" : "Low";
};

export const hirarcQualityIssues = (assessment: HirarcAssessment): string[] => {
  const issues: string[] = [];
  if (!assessment.activity.trim()) issues.push("Work activity is missing.");
  if (!assessment.hazard.trim()) issues.push("Hazard is missing.");
  if (!assessment.consequence.trim()) issues.push("Cause or effect is missing.");
  if (!assessment.personsAtRisk.trim()) issues.push("Persons at risk are not identified.");
  if (!assessment.owner.trim()) issues.push("PIC is missing.");
  if (!assessment.recommendedControls.trim()) issues.push("Recommended controls are missing.");
  if (assessment.status === "complete" && !assessment.reviewDate)
    issues.push("Completed assessment has no review date.");
  return issues;
};
